import { render, staticRenderFns } from "./CommissioneFondi.vue?vue&type=template&id=838373d4&"
import script from "./CommissioneFondi.vue?vue&type=script&lang=js&"
export * from "./CommissioneFondi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports